import React from 'react';
import { Product } from '../types';

interface ProductListProps {
  products: Product[];
  onSelectProduct: (product: Product) => void;
  isLoading: boolean;
}

const ProductList: React.FC<ProductListProps> = ({ products, onSelectProduct, isLoading }) => {
  if (isLoading) {
    return (
      <div className="w-full max-w-6xl mx-auto px-4 py-12">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-4 border-primary-200 border-t-primary-700"></div>
          <p className="text-text-secondary text-lg">Carregando produtos...</p>
        </div>
      </div>
    );
  }

  if (products.length === 0) {
    return (
      <div className="w-full max-w-6xl mx-auto px-4 py-12">
        <div className="bg-gradient-card rounded-2xl shadow-soft-lg p-12 text-center border border-white/50">
          <div className="text-6xl mb-4">🎉</div>
          <h3 className="text-2xl font-bold text-text-primary mb-2">
            Todos os produtos foram selecionados!
          </h3>
          <p className="text-lg text-text-secondary">
            Muito obrigado pela ajuda de todos(as)! 💝
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-6xl mx-auto px-4 py-8">
      <div className="text-center mb-10">
        <h2 className="text-4xl md:text-5xl font-bold text-text-primary mb-3">
          Lista de Produtos
        </h2>
        <div className="w-32 h-1 bg-gradient-to-r from-primary-500 to-primary-600 mx-auto rounded-full mb-4"></div>
        <p className="text-text-secondary text-lg">
          Clique em um produto para selecioná-lo e preencha com seu nome e telefone
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {products.map((product, index) => (
          <button
            key={product.id}
            onClick={() => onSelectProduct(product)}
            className="group bg-gradient-card backdrop-blur-sm rounded-xl shadow-soft p-6 text-left border border-white/50 transform transition-all duration-300 hover:shadow-soft-lg hover:scale-105 hover:-translate-y-1 hover:border-primary-300"
            style={{ animationDelay: `${index * 50}ms` }}
          >
            <div className="flex items-start justify-between mb-3">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-100 to-primary-200 rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                <span className="text-2xl">🎁</span>
              </div>
              <span className="text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity">
                →
              </span>
            </div>
            <h3 className="text-lg font-bold text-text-primary mb-2 group-hover:text-primary-700 transition-colors">
              {product.nome}
            </h3>
            <p className="text-sm text-text-secondary">
              Clique para selecionar
            </p>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductList;



